module.exports = __webpack_public_path__ + "static/WEDDING E&M-81-5df83d4722869604159d30531c375dcd.jpg";